export { default } from './Manufacturing';
